class MarqueeComponent extends HTMLElement {
  connectedCallback() {
    this.wrapper = this.querySelector('.marquee__wrapper');
    this.content = this.querySelector('.marquee__content');

    if (!this.wrapper || !this.content) return;

    this.cloneContent();
    this.start();
  }

  cloneContent() {
    const clone = this.content.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    this.wrapper.appendChild(clone);
  }

  start() {
    const speedFactor = Number(this.dataset.speedFactor || 20);
    const width = this.offsetWidth;
    const duration = width / speedFactor;

    this.style.setProperty('--marquee-speed', `${duration}s`);
  }
}

if (!customElements.get('marquee-component')) {
  customElements.define('marquee-component', MarqueeComponent);
}
